import { transformImageUrl } from '@kontent-ai/delivery-sdk'
import { defineProvider } from '@nuxt/image/runtime'

export default defineProvider({
  getImage: (src) => {
    const transformedUrl = transformImageUrl(src).withAutomaticFormat().getUrl()

    return {
      url: transformedUrl
    }
  }
})
